import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-instance-history-result-modal',
  templateUrl: './instance-history-result-modal.component.html',
  styleUrls: ['./instance-history-result-modal.component.css']
})
export class InstanceHistoryResultModalComponent implements OnInit {

  @Input() modalTitle: string;
  objInitialState;
  filter;
  availableBusinessProcess;
  tableMaxHeight;
  stateName;
  lifeCycleName;

  constructor(public bsModalRef: BsModalRef) {

  }

  ngOnInit() {
    this.tableMaxHeight = '65vh';
    if (this.objInitialState){
      this.availableBusinessProcess = this.objInitialState.availableBusinessProcess;
      this.filter = this.objInitialState.filter;
      this.stateName = this.objInitialState.stateName;
      this.lifeCycleName = this.objInitialState.lifeCycleName;
    }
  }

  onClose() {
    this.bsModalRef.hide();
  }
}
